import * as THREE from 'three'
import Experience from '../Experience.js'

// import vertexShader from '../../Experience/shaders/vertex.glsl'

export default class LeePerrySmith
{
    constructor()
    {
        this.experience = new Experience()
        this.scene = this.experience.scene
        this.resources = this.experience.resources
        this.time = this.experience.time
        this.debug = this.experience.debug

        // Debug
        if(this.debug.active)
        {
            this.debugFolder = this.debug.ui.addFolder('LeePerrySmith')
            // this.debugFolder.close()
        }

        // Resource
        this.resource = this.resources.items.leePerrySmithModel

        this.setTextures()
        this.setMaterial()
        this.setModel()
    }

    setTextures()
    {
        this.textures = {}

        this.textures.color = this.resources.items.mapTexture
        this.textures.color.colorSpace = THREE.SRGBColorSpace
        this.textures.normal = this.resources.items.normalTexture
    }

    setMaterial()
    {
        this.material = new THREE.MeshStandardMaterial({
            map: this.textures.color,
            normalMap: this.textures.normal,
            // uniforms: 
            // {
            //     uSpeed: { value : 0.003 }
            // }
        })

        /**
         * Animate shadow
         */
        this.shadowDepthMaterial = new THREE.MeshDepthMaterial({
            depthPacking: THREE.RGBADepthPacking
        })

        /**
         * Animate material
         */

        this.customUniforms = { 
            uTime: { value :0 },
            uSpeed: { value : 0.003 },
            uAmplitude: { value : 0.22 },
            uWeaveLenght: { value : 1 },
            uWeaveHeight: { value : 0.3 }
        }

        /**
         * Hook material
         */
        this.material.onBeforeCompile = (shader) =>
        {
            shader.uniforms.uTime = this.customUniforms.uTime
            shader.uniforms.uSpeed = this.customUniforms.uSpeed
            shader.uniforms.uAmplitude = this.customUniforms.uAmplitude
            shader.uniforms.uWeaveLenght = this.customUniforms.uWeaveLenght
            shader.uniforms.uWeaveHeight = this.customUniforms.uWeaveHeight
            
            shader.vertexShader = shader.vertexShader.replace(
                '#include <common>',
                `
                    #include <common>

                    uniform float uTime;
                    uniform float uSpeed;
                    uniform float uAmplitude;
                    uniform float uWeaveLenght;
                    uniform float uWeaveHeight;

                    mat2 get2dRotateMatrix(float _angle)
                    {
                        return mat2(cos(_angle), - sin(_angle), sin(_angle), cos(_angle));
                    }
                `
            )
            shader.vertexShader = shader.vertexShader.replace(
                '#include <beginnormal_vertex>',
                `
                    #include <beginnormal_vertex>

                    float angle = sin(position.y * uWeaveLenght + uTime * uSpeed) * uAmplitude;
                    mat2 rotateMatrix = get2dRotateMatrix(angle);

                    // objectNormal.xz = objectNormal.xz * rotateMatrix;
                    objectNormal.x *= (1.0 + sin(position.y * uWeaveLenght + uTime * uSpeed) * uAmplitude) * ((position.y + 4.0) * uWeaveHeight);
                    objectNormal.y *= (1.0 + cos(position.y * uWeaveLenght + uTime * uSpeed) * uAmplitude) ;
                    objectNormal.z *= (1.0 + sin(position.y * uWeaveLenght + uTime * uSpeed) * uAmplitude) * ((position.y + 4.0) * uWeaveHeight);
                `
            )
            shader.vertexShader = shader.vertexShader.replace(
                '#include <begin_vertex>',
                `
                    #include <begin_vertex>

                    // float angle = sin(position.y * uWeaveLenght + uTime * uSpeed) * uAmplitude;
                    // mat2 rotateMatrix = get2dRotateMatrix(angle);

                    // transformed.xz = transformed.xz * rotateMatrix;
                    transformed.x *= (1.0 + sin(position.y * uWeaveLenght + uTime * uSpeed) * uAmplitude) * ((position.y + 4.0) * uWeaveHeight);
                    transformed.y *= (1.0 + cos(position.y * uWeaveLenght + uTime * uSpeed) * uAmplitude) ;
                    transformed.z *= (1.0 + sin(position.y * uWeaveLenght + uTime * uSpeed) * uAmplitude) * ((position.y + 4.0) * uWeaveHeight);
                    if(transformed.y < - 1.0){transformed.y *= sin(position.y * uWeaveLenght + uTime * uSpeed);}
                `
            )
        }
        /**
         * Hook Shadows 
         */
        this.shadowDepthMaterial.onBeforeCompile = (shader) =>
        {
            shader.uniforms.uTime = this.customUniforms.uTime
            shader.uniforms.uSpeed = this.customUniforms.uSpeed
            shader.uniforms.uAmplitude = this.customUniforms.uAmplitude
            shader.uniforms.uWeaveLenght = this.customUniforms.uWeaveLenght
            shader.uniforms.uWeaveHeight = this.customUniforms.uWeaveHeight

            shader.vertexShader = shader.vertexShader.replace(
                '#include <common>',
                `
                    #include <common>
                    
                    uniform float uTime;
                    uniform float uSpeed;
                    uniform float uAmplitude;
                    uniform float uWeaveLenght;
                    uniform float uWeaveHeight;

                    mat2 get2dRotateMatrix(float _angle)
                    {
                        return mat2(cos(_angle), - sin(_angle), sin(_angle), cos(_angle));
                    }
                `
            )
            shader.vertexShader = shader.vertexShader.replace(
                '#include <begin_vertex>',
                `
                    #include <begin_vertex>
                    // transformed.y += 10.0;
                    float angle = sin(position.y * uWeaveLenght + uTime * uSpeed) * uAmplitude;
                    
                    mat2 rotateMatrix = get2dRotateMatrix(angle);
                    // transformed.xz = transformed.xz * rotateMatrix;
                    transformed.x *= (1.0 + sin(position.y * uWeaveLenght + uTime * uSpeed) * uAmplitude) * ((position.y + 4.0) * uWeaveHeight);
                    transformed.y *= (1.0 + cos(position.y * uWeaveLenght + uTime * uSpeed) * uAmplitude) ;
                    transformed.z *= (1.0 + sin(position.y * uWeaveLenght + uTime * uSpeed) * uAmplitude) * ((position.y + 4.0) * uWeaveHeight);
                `
            )
        }
        /**
         * Debug
         */
        // Debug
        if(this.debug.active)
        {
            this.debugFolder.add(this.customUniforms.uSpeed, 'value', 0.001, 0.03, 0.001).name('uSpeed')
            this.debugFolder.add(this.customUniforms.uAmplitude, 'value', 0.01, 1, 0.01).name('uAmplitude')
            this.debugFolder.add(this.customUniforms.uWeaveLenght, 'value', 0.01, 5, 0.01).name('uWeaveLenght')
            this.debugFolder.add(this.customUniforms.uWeaveHeight, 'value', 0.01, 5, 0.01).name('uWeaveHeight')
        }
    }

    setModel()
    {
        // Set model
        this.model = this.resource.scene.children[0]
        
        // Set material
        this.model.material = this.material
        this.model.customDepthMaterial = this.shadowDepthMaterial

        // Set deformations
        this.model.rotation.y = Math.PI * 0.5
        const debugObject = { scale: 1.0 }
        this.model.scale.set (debugObject.scale, debugObject.scale, debugObject.scale)
        
        this.scene.add(this.model)

        this.model.traverse((child) =>
        {
            if(child instanceof THREE.Mesh)
            {
                child.castShadow = true
                child.receiveShadow = true
            }

            if(child instanceof THREE.Mesh && child.material instanceof THREE.MeshStandardMaterial)
            {
                child.material.envMapIntensity = 1
                child.material.needsUpdate = true
            }
        })

        // Debug
        if(this.debug.active)
        {
            this.debugFolder.add(debugObject, 'scale', 0.01, 2, 0.01)
            .onChange(() => {
                this.model.scale.set (debugObject.scale, debugObject.scale, debugObject.scale)
            })
        }
    }

    update()
    {
        // Update material
        this.customUniforms.uTime.value = this.time.elapsed
        // console.log(this.customUniforms.uTime.value)

        // Update model
        // this.model.update()
    }
}